<template>
    <div class="grid-container" :style="gridStyle">
        <div class="grid-separator grid-separator--vertical" v-for="separator of verticalSeparators"
             :style="{gridRowEnd: rows, gridColumn: `${separator} / ${separator + 1}`}"
             :key="'separator-v-' + separator"></div>
        <div class="grid-separator grid-separator--horizontal" v-for="separator of horizontalSeparators"
             :style="{gridColEnd: cols, gridRow: `${separator} / ${separator + 1}`}"
             :key="'separator-h-' + separator"></div>
        <slot></slot>
    </div>
</template>

<script>
import horizontalBarExample from 'vue-chartjs/es/examples/HorizontalBarExample';

export default {
    name: 'GridView',
    props: {
        cols: Number,
        rows: Number,
        cellWidth: {
            type: String,
            defaults: () => null,
        },
        cellHeight: {
            type: String,
            defaults: () => null,
        },
        firstColumn: {
            type: String,
            defaults: () => null,
        },
        verticalSeparators: {
            type: Array,
            defaults: () => [],
        },
        horizontalSeparators: {
            type: Array,
            defaults: () => [],
        },
    },
    computed: {
        gridStyle() {
            const cellWidth = this.cellWidth || '1fr';
            const cellHeight = this.cellHeight || 'auto';
            const gridTemplateColumns = ( this.firstColumn ? this.firstColumn + ' ' : '' ) + `repeat(${this.cols}, ${cellWidth})`;

            return {
                gridTemplateColumns,
                gridAutoRows: cellHeight,
            };
        },
    },
}
</script>

<style scoped>

.grid-container {
    display: grid;
    grid-gap: 0;
    grid-auto-flow: row;
    overflow: auto;
}

.grid-separator {
    position: relative;
}

.grid-separator--vertical {
    border-right: 1px solid var(--contrast-3);
    margin-right: -1px;
    width: 0;
    grid-row: 1 / -1;
}

.grid-separator--horizontal {
    border-bottom: 1px solid var(--contrast-3);
    margin-top: -1px;
    height: 0;
    grid-column: 1 / -1;
}

</style>
